import React from 'react';
import { palette } from '../styles/Palette';

const CoinFill = ({ width = "10", height = "6", color = palette.gray500, ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 10 6" 
      fill="none"
      {...props}
    >
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M0.400146 3.2304V4.02874C0.400146 4.09292 0.444845 4.23528 0.655268 4.43855C0.856716 4.63316 1.16671 4.83968 1.57433 5.02872C2.3874 5.40581 3.5296 5.68588 4.80015 5.68588C6.0707 5.68588 7.21289 5.40581 8.02597 5.02872C8.43358 4.83968 8.74358 4.63316 8.94502 4.43855C9.15545 4.23528 9.20015 4.09292 9.20015 4.02874V3.23032C8.96016 3.40771 8.67537 3.56993 8.3593 3.71315C7.43395 4.13245 6.17693 4.41772 4.8001 4.41772C3.42326 4.41772 2.16625 4.13245 1.24089 3.71315C0.924869 3.56995 0.640112 3.40776 0.400146 3.2304ZM0.400146 1.97469V1.9716C0.400146 1.90742 0.444845 1.76506 0.655268 1.56178C0.856716 1.36718 1.16671 1.16066 1.57433 0.971612C2.3874 0.594521 3.5296 0.314453 4.80015 0.314453C6.0707 0.314453 7.21289 0.594521 8.02597 0.971612C8.43358 1.16066 8.74358 1.36718 8.94502 1.56178C9.15062 1.76039 9.19801 1.90086 9.20007 1.96705C9.20009 1.96811 9.2001 1.96915 9.2001 1.97018C9.2001 2.05333 9.14956 2.20259 8.94396 2.40262C8.74421 2.59696 8.43615 2.80002 8.02912 2.98446C7.21722 3.35236 6.07423 3.61772 4.8001 3.61772C3.52596 3.61772 2.38298 3.35236 1.57108 2.98446C1.16404 2.80002 0.855989 2.59696 0.656238 2.40262C0.454302 2.20615 0.40195 2.05867 0.400146 1.97469Z" 
      fill={color}
    />
    </svg>
  );
};

export default CoinFill; 